export const SegmentEventName = {
    AI_WORKFLOW_COMPLETED: 'AI Workflow - Completed',
    AI_WORKFLOW_ERROR: 'AI Workflow - Error',
    AI_WORKFLOW_REPORT_SHARED: 'AI Workflow - Report Shared',
    AI_WORKFLOW_SUBMITTED: 'AI Workflow - Submitted',
    CATEGORY_PERFORMANCE_SUBCATEGORIES_TAB_VIEWED:
        'User views the Subcategories tab',
    CATEGORY_PERFORMANCE_TRAFFIC_AND_CONVERSION_TAB_VIEWED:
        'User views the Traffic & Conversion tab',
    CTA_CLICKED: 'CTA Clicked',
    INSIGHTS_FEEDBACK_SUBMITTED: 'Insights - Feedback Submitted',
    INSIGHTS_INSIGHT_SELECTED: 'Insights - Insight Selected',
    LOGIN_ERROR: 'Login - Login Error',
    LOGIN_MFA_CHALLENGE: 'Login - MFA Challenge',
    LOGIN_SUCCESS: 'Login - Login Success',
    KEYWORD_RESEARCH_KEYWORDS_SEARCHED: 'Keywords Searched',
    KEYWORD_RESEARCH_SOV_DROPDOWN_CLICK:
        'Keyword Research - SOV Dropdown Click',
    KEYWORD_RESEARCH_SOV_DROPDOWN_OPEN: 'Keyword Research - SOV Dropdown Open',
    LOGIN_STARTED: 'Login - Login Started',
    LOGIN_USER_NOT_CONFIRMED: 'Login - User Not Confirmed',
    METRICS_GLOSSARY_SEARCH_BAR_NO_RESULTS_FOUND:
        'MetricsGlossary - Search Bar No Results Found',
    MFA_ADD_PHONE_NUMBER_STARTED: 'MFA - Add Phone Number Started',
    MFA_INSERT_SMS_CODE_STARTED: 'MFA - Insert SMS Code Started',
    MFA_LOGIN_ERROR: 'MFA - Login Error',
    MFA_LOGIN_SESSION_EXPIRED: 'MFA - Login Session Expired',
    MFA_LOGIN_SUCCESS: 'MFA - Login Success',
    MFA_PHONE_NUMBER_ADD_ERROR: 'MFA - Phone Number Add Error',
    MFA_PHONE_NUMBER_ADD_SUCCESS: 'MFA - Phone Number Add Success',
    MFA_PHONE_NUMBER_VERIFY_ERROR: 'MFA - Phone Number Verify Error',
    MFA_PHONE_NUMBER_VERIFY_SUCCESS: 'MFA - Phone Number Verify Success',
    MFA_VERIFY_PHONE_NUMBER_STARTED: 'MFA - Verify Phone Number Started',
    ORG_CHANGED: 'Org changed',
    ORG_GROUP_CHANGED: 'Org group changed',
    SIGIL_CTA_VIEWED: 'Sigil CTA - Viewed',
    SIGNED_IN: 'Signed In',
    SIGN_UP_ERROR: 'Signup - Signup Error',
    SIGN_UP_SUCCESS: 'Signup - Signup Success',
    SIGN_UP_STARTED: 'Sign Up - Sign Up Started',
    SIGN_UP_VERIFY_EMAIL_ERROR: 'Signup - Verify Email Error',
    SIGN_UP_VERIFY_EMAIL_STARTED: 'Sign Up - Verify Email Started',
    SIGN_UP_VERIFY_EMAIL_SUCCESS: 'Signup - Verify Email Success',
    UPGRADE_INTEREST_CLICKED: 'Upgrade Interest Clicked',
    WHATS_NEW_OPENED: "What's New - Opened",
    WIDGET_SAVED: 'Widget Saved',
    WIDGET_UNIQUE_SAVED_OR_UPDATED: 'Widget Unique Saved or Updated',
} as const

export type SegmentEventNameValue =
    (typeof SegmentEventName)[keyof typeof SegmentEventName]
